<template>
  <div class="product-size-table">
    <ModalAsideHeader>
      <DefTitle :result="2">
        <h2>{{ messages.sizes.title }}</h2>
      </DefTitle>
    </ModalAsideHeader>
    <div v-if="screenWidth >= 768" class="size-tabs">
      <span
        v-for="size in sizesTable"
        :key="size.id"
        :class="{ 'size-tabs__item_active': size.active }"
        class="size-tabs__item"
        @click="changeSizeTab(size.id)"
      >
        {{ size.name }}
      </span>
    </div>
    <DefSelectWrapper v-else>
      <template #placeholder>
        {{ messages?.sizes?.typeDecoration }}
      </template>
      <template #header>
        {{ getActiveTable?.name }}
      </template>
      <div v-for="size in sizesTable" :key="size.id" @click="changeSizeTab(size.id)">
        {{ size.name }}
      </div>
    </DefSelectWrapper>
    <div v-html="getActiveTable?.detailText"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DefSelectWrapper from '@components/Def/DefSelect/DefSelectWrapper.vue';
import useScreenWidth from '@use/useScreenWidth';
import ModalAsideHeader from '@use/useModalAside/ModalAsideHeader.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';

export default {
  name: 'ProductSizeTable',
  components: { DefTitle, ModalAsideHeader, DefSelectWrapper },
  data() {
    return {
      screenWidth: useScreenWidth(),
      isOpenSizeTable: false,
    };
  },
  computed: {
    ...mapState({
      sizesTable: ({ product }) => product?.data?.product?.sizesTable,
      messages: ({ product }) => product?.data?.messages,
    }),
    getActiveTable() {
      return this.sizesTable?.find((el) => el.active);
    },
  },
  methods: {
    ...mapMutations({
      changeSizeTab: 'product/changeSizeTab',
    }),
  },
};
</script>

<style lang="scss" scoped>
.product-size-table {
  margin-bottom: 32px;
  @include point-lg {
    margin-bottom: 24px;
  }
  &__link {
    display: inline-flex;
  }
  &__icon {
    transition: 0.2s linear fill;
    fill: currentColor;
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }
  :deep(.modal-aside-header) {
    margin-bottom: 24px;
  }
}
.size-tabs {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--border-grey);
  &__item {
    font-weight: 600;
    font-size: rem(12);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding-bottom: 12px;
    cursor: pointer;
    border-bottom: 1px solid transparent;
    transform: translateY(1px);
    transition: 0.2s linear border-bottom-color;
    &:not(:last-child) {
      margin-right: 40px;
    }
    &_active {
      border-bottom-color: var(--border-colour-primary);
    }
  }
}
:deep(.size-table__row) {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: 16px;
  @include point-md {
    grid-column-gap: 24px;
  }
}
:deep(.size-table__row) {
  font-weight: 500;
  font-size: rem(12);
  line-height: 120%;
  color: var(--color-dark-grey);
  @include point-md {
    font-size: rem(14);
    line-height: 125%;
    font-weight: 500;
  }
}
:deep(.size-table__header) {
  display: grid;
  grid-row-gap: 16px;
  grid-auto-rows: min-content;
}
:deep(.product-size-table__grid) {
  margin-top: 16px;
  @include point-md {
    display: grid;
    grid-template-columns: 1fr 0.8fr;
    grid-column-gap: 24px;
    margin-top: 40px;
  }
}
:deep(img) {
  display: none;
  @include point-md {
    display: block;
  }
}
</style>
